import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=20ea03fb&scoped=true&"
import script from "./FullScreen.vue?vue&type=script&lang=js&"
export * from "./FullScreen.vue?vue&type=script&lang=js&"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=20ea03fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ea03fb",
  null
  
)

export default component.exports